import axios from 'axios';

const adminApi = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'https://api.lotwleague.com/api'
    : process.env.REACT_APP_API_URL || 'http://192.168.86.41:3001/api',
  withCredentials: true
});

// Request interceptor
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Named exports for individual methods
export const getAllUsers = () => adminApi.get('/admin/users');
export const getUserDetails = (userId) => adminApi.get(`/admin/users/${userId}/details`);
export const updateUserRole = (userId, role) => adminApi.put(`/admin/users/${userId}/role`, { role });
export const resetUserPassword = (userId, password) => adminApi.put(`/admin/users/${userId}/password`, { password });
export const updateUserDetails = (userId, details) => adminApi.put(`/admin/users/${userId}`, details);

// Watch management
export const fetchWatchData = () => adminApi.get('/admin/watch-data');
export const deleteWatch = (userId, gameId, pickType, week) =>
  adminApi.delete(`/admin/watch-data/${userId}/${gameId}/${pickType}/${week}`);
export const purgeAllWatches = () => adminApi.delete('/admin/watch-data');

// Game management
export const fetchGamesForWeek = (week) => adminApi.get(`/admin/games?week=${week}`);
export const getAllGames = () => adminApi.get('/admin/games');
export const getGameDetails = (gameId) => adminApi.get(`/admin/games/${gameId}`);

// User activity
export const getUserWatches = (userId, year) => adminApi.get(`/admin/users/${userId}/watches?year=${year}`);
export const getUserLocks = (userId, year) => adminApi.get(`/admin/users/${userId}/locks?year=${year}`);

// Manual operations
export const createManualLock = (lockData) => adminApi.post('/admin/manual-lock', lockData);
export const triggerAudit = () => adminApi.post('/admin/trigger-audit');

// API Status
export const getGlobalApiStatus = () => adminApi.get('/admin/global_api_status');
export const getApiTablesStatus = () => adminApi.get('/admin/api_tables_status');

// Add version endpoint
export const getServerVersion = () => adminApi.get('/system/version');

// Also export the entire api object as default
export default adminApi;
